<mat-card class="card">
  <mat-card-content class="card-content">
    <mat-card-header class="info-card-header flex row">
      <mat-card-title class="title row">{{ "Customers.Locations.LocationsList" | translate }}</mat-card-title>

      <div *ngIf="(RolesConstants.CUSTOMER_EDIT | userRoleChecker) && !readOnly" (click)="onAddMoreLocations()" class="add-locations">
        <img class="mx-2" src="../../../../../assets/images/add.svg" />
        <span *ngIf="locations?.length">{{'Location.AddMoreLocations' | translate}}</span>
        <span *ngIf="!locations?.length">{{'Location.AddLocation' | translate}}</span>
      </div>
    </mat-card-header>

    <div class="my-5">
      <mat-divider class="pos-static"></mat-divider>
    </div>

    <section class="locations-list-wrapper">
      <app-entity-listing
        [totalCount]="totalRowsCount"
        [addTopSpace]="false"
        [state]="sectionState"
        [pageIndex]="filters.params.offset + 1"
        [pageSize]="filters.params.limit"
        [emptyStateMainLabel]="'Customers.Locations.emptyStateMainLabel' | translate"
        [emptyStateSubLabel]="'Customers.Locations.emptyStateSubLabel' | translate"
        [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate"
        (pageIndexChanged)="filters.params = { offset: $event - 1 }"
      >
        <table mat-table [dataSource]="dataSource" matSort class="table scrollable scrollable--x">
          <ng-container matColumnDef="defaultIcon">
            <th mat-header-cell *matHeaderCellDef [hidden]="!showAddLocationTypeColumn"></th>
            <td mat-cell *matCellDef="let location" [hidden]="!showAddLocationTypeColumn">
              <app-icon 
              class="icon icon--xsmall"
              [name]="location.isDefault ? 'default-location' : 'regular-location'" 
              [matTooltip]=" 'Location.DefaultLocation' | translate" 
              ></app-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="type" *ngIf="false">
            <th mat-header-cell *matHeaderCellDef [hidden]="!showAddLocationTypeColumn">{{ "Customers.Locations.Type" | translate }}</th>
            <td mat-cell *matCellDef="let location" [hidden]="!showAddLocationTypeColumn">
              <div>{{ 'Enum.AddLocationType.' + location?.locationType | translate }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="locationName">
            <th mat-header-cell *matHeaderCellDef>{{ "Customers.Locations.Name" | translate }}</th>
            <td mat-cell *matCellDef="let location">
              <div>{{ location?.title||'_______' }}</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="city">
            <th mat-header-cell *matHeaderCellDef>{{ "Customers.Locations.City" | translate }}</th>
            <td mat-cell *matCellDef="let location">
              <div>{{ location?.city?.name ||'_______' }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="shipment">
            <th mat-header-cell *matHeaderCellDef>{{ "Table.Shipments" | translate }}</th>
            <td mat-cell *matCellDef="let location">
              <div>{{ location?.totalShipmentsCount || '_____' }}</div>
            </td>
          </ng-container>
          
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>{{ "Table.Status" | translate }}</th>
            <td mat-cell *matCellDef="let location">
              <app-rect-tag *ngIf="location.status" [color]="location?.status === LocationStatus.Active ? 'success' : 'default'">{{ 'Enum.Status.' + location?.status | translate}}</app-rect-tag>
              <div *ngIf="!location.status">{{ '_____' }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="Latitude&Longitude">
            <th mat-header-cell *matHeaderCellDef>{{ "Customers.Locations.Lat&Long" | translate }}</th>
            <td mat-cell *matCellDef="let location">
              <div>{{ location?.latitude }}, {{location?.longitude}}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef>{{ "Customers.Locations.Address" | translate }}</th>
            <td mat-cell *matCellDef="let location">
              <div class="tooltip">
                <div class="limited-text">{{ location?.address ||'_______' }}</div>
                <div class="tooltiptext weight-bold">{{ location?.address ||'_______' }}</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="shippingType">
            <th mat-header-cell *matHeaderCellDef>{{ "Inputs.ShippingType" | translate }}</th>
            <td mat-cell *matCellDef="let location">{{ ("Enum.ShippingType." + location.shippingType | translate) || "_____" }}</td>
          </ng-container>

          <ng-container matColumnDef="contacts">
            <th mat-header-cell *matHeaderCellDef>{{ "Location.Labels.Contacts" | translate }}</th>
            <td mat-cell *matCellDef="let location">
              <ng-container *ngIf="location.usersLocations?.length">
                <div class="tooltip">
                  <div *ngFor="let userLocation of location.usersLocations; let i = index">
                    <div *ngIf="i < 3" class="list">
                      <div class="list__text">{{ userLocation.user?.firstName + '-' + userLocation.user?.lastName }}</div>
                      <div *ngIf="i == 2 && location.usersLocations.length - 3 > 0" class="list__count">
                        + {{ location.usersLocations.length - 3 }}
                      </div>
                    </div>
                  </div>
                  <div class="tooltiptext">
                    <ul class="px-2 my-0">
                      <li *ngFor="let userLocation of location.usersLocations" class="mb-1 weight-bold">
                        {{ userLocation.user?.firstName + '-' + userLocation.user?.lastName }}
                      </li>
                    </ul>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="!location.usersLocations?.length">_______</ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="reference">
            <th mat-header-cell *matHeaderCellDef>{{ "sharedFeatures.GateDefinition.referenceID" | translate }}</th>
            <td mat-cell *matCellDef="let location">{{ (location?.reference | translate) || "_____" }}</td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th class="center" mat-header-cell *matHeaderCellDef>{{ "Customers.Table.Actions" | translate }}</th>

            <td
              app-click-stop-propagation
              [matMenuTriggerFor]="menu"
              class="center action"
              mat-cell
              *matCellDef="let location"
              app-click-stop-propagation
            >
              <div class="flex justify-center align-center">
                <div class="flex justify-center">
                  <app-icon name="menu-vert"  class="cursor-pointer text-700"></app-icon>
                </div>

                <mat-menu class="item-actions" #menu>

                  <mat-option *ngIf="(RolesConstants.LOCATION_STATUS_EDIT  | userRoleChecker)" (click)="onChangeStatus(location)">
                    <span>{{ (location?.status === LocationStatus.Active ?  "Location.Deactivate" : "Location.Activate") | translate }}</span>
                  </mat-option>

                  <mat-option (click)="onNavigateToMap(location)">
                    <span>{{ "Customers.Locations.ShowOnMap" | translate }}</span>
                  </mat-option>

                  <mat-option (click)="onSetAsDefault(location)" *ngIf="!readOnly && !location.isDefault">
                    <span>{{ "Location.SetAsDefault" | translate }}</span>
                  </mat-option>
                  <mat-option (click)="onSelectLocation(location); matDialog.open(addLocationModal)" *ngIf="!readOnly">
                    <span>{{ "Buttons.Edit" | translate }}</span>
                  </mat-option>

                  <mat-option
                    [routerLink]="RoutesUtil.CustomersB2BView.url({ id: location.id })"
                    *ngIf="location.locationType === AddLocationType.Customer && false"
                  >
                    <span>{{ "Buttons.Details" | translate }}</span>
                  </mat-option>
                </mat-menu>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="onNavigateToMap(row)"></tr>
        </table>
      </app-entity-listing>
    </section>
  </mat-card-content>
</mat-card>

<ng-template #addLocationModal>
  <app-dialog-layout class="dialog-layout madar--v2">
    <ng-container dialog-title>{{ (selectedLocation?.id ? 'Location.EditLocation' : 'Location.AddLocation') | translate }}</ng-container>
    <div dialog-content class="mt-3">
      <app-add-location
        (closeModal)="matDialog?.closeAll()"
        (reloadComponent)="reload.emit();"
        (updatedLocation)="onUpdateLocation($event)"
        (locationId)="onAddLocation($event)"
        [item]="item"
        [location]="selectedLocation"
        [type]="type"
      ></app-add-location>
    </div>
  </app-dialog-layout>
</ng-template>
